import React, { Component } from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';

// @TODO fix the jumping input box when adding the error class
// @TODO align the numbers in the input box...
// @TODO check translation of the texts

class ConfirmEmail extends Component {
    static _codeValid(code) {
        const onlyNumbers = /^[0-9]+$/i;

        return code.match(onlyNumbers) != null && code.length === 6;
    }

    constructor(props) {
        super(props);

        this.state = {
            codeValid: false,
            codeTouched: false,
            code: '',
        };
    }

    componentDidMount() {
        const { userId, code } = this.props;

        if (userId && code) {
            // we got the code prefilled, so it was due to a confirmation link:
            this.setState({
                // eslint-disable-next-line react/no-unused-state
                userId,
                code,
                codeTouched: true,
                codeValid: this.constructor._codeValid(code),
            });

            this.props.confirmEmail(userId, code);
        }
    }

    _onSubmit = (e) => {
        e.preventDefault();

        const { userId } = this.props;
        const { code, codeValid } = this.state;

        if (!codeValid) {
            return false;
        }

        return this.props.confirmEmail(userId, code);
    }

    _resendConfirmationEmail = () => this.props.resendConfirmationEmail(this.props.userId, this.props.name, this.props.email)

    _handleFieldUpdate(e) {
        const value = e.target ? e.target.value : '';

        this.setState({
            code: value,
            codeTouched: true,
            codeValid: this.constructor._codeValid(value),
        });
    }

    render() {
        const { code, codeValid, codeTouched } = this.state;
        const { submitting, emailConfirmed, email } = this.props;
        const inputFieldError = codeTouched && !codeValid;
        const fieldClass = `inputCode ${inputFieldError && ' inputErrorBox'}`;
        const disabled = !codeValid || !!submitting;

        return (
            <section className="sectionConfirmEmail">
                <header>
                    <h2>Confirmação de e-mail</h2>
                    {
                        !emailConfirmed ?
                            <div className="confirmEmailSubtitle">
                                <p>Enviamos um código de confirmação para o e-mail: <strong>{email}</strong>. Copie e cole o código no campo abaixo, ou clique em verificar seu cadastro automaticamente.</p>
                            </div>
                            :
                            <p>E-mail confirmado com sucesso! Aguarde...</p>
                    }
                </header>
                {!emailConfirmed &&
                    <form className="confirmEmailForm" onSubmit={this._onSubmit.bind(this)}>
                        <input
                            className={fieldClass}
                            type="text"
                            placeholder="Insira o código aqui"
                            id="code"
                            value={code}
                            onChange={this._handleFieldUpdate.bind(this)}
                        />
                        {
                            inputFieldError && (
                                <p className="tw-text-center">O código de confirmação tem 6 números</p>
                            )
                        }
                        <button type="submit" className="cta tw-my-2" disabled={disabled} style={codeValid ? { cursor: 'pointer' } : undefined}>
                            {submitting === 'confirmEmail' ? 'Validando...' : (codeValid ? 'Validar código' : 'Insira um código válido')}
                        </button>
                        <button
                            type="button"
                            className="cta"
                            onClick={this._resendConfirmationEmail.bind(this)}
                            disabled={this.props.resending || this.props.statusOfEmailResent}
                        >
                            {this.props.resending ? 'Enviando...'
                                : this.props.statusOfEmailResent
                                    ? 'Um novo código foi enviado para o seu e-mail'
                                    : 'Reenviar código de confirmação'}
                        </button>
                    </form>}
            </section>
        );
    }
}

ConfirmEmail.propTypes = exact({
    confirmEmail: PropTypes.func.isRequired,
    userId: PropTypes.number.isRequired,
    code: PropTypes.string,
    emailConfirmed: PropTypes.bool,
    name: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    resendConfirmationEmail: PropTypes.func,
    resending: PropTypes.bool,
    statusOfEmailResent: PropTypes.bool,
    submitting: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.string,
    ]).isRequired,
});

export default ConfirmEmail;
